export default __webpack_public_path__ + "static/1.2_FR-a8ae868142067502b50eea3fb6aece3b.webp";